import { createRouter, createWebHashHistory } from 'vue-router';
import SharePage from './SharePage.vue';

export const shareRouter = createRouter({
    history: createWebHashHistory(),
    routes: [
        {
            // 适配社交媒体分享，重定向到分享详情页。用于处理facebook、linkedin平台插入参数/截断vue路由的问题
            path: '/',
            component: {
                render() {
                    return null;
                },
            },
            beforeEnter: (to, from, next) => {
                const url = new URL(location.href);
                const searchParams = url.searchParams
                const shareId = searchParams.get('id');
                searchParams.delete('id')
                const searchStr = searchParams.toString()
                url.search = ''
                console.log('Redirect to share detail', url.href);
                history.pushState({}, '', url)
                next(`/${shareId}?${searchStr}`);
            },
        },
        {
            name: 'ShareDetail',
            path: '/:share_id',
            component: SharePage,
        }
    ],
})

export default shareRouter;
